window.Shopify = window.Shopify || {}

window.ShopifyApi = window.ShopifyApi || {}


const getLocale = () => {
  const lang = document.documentElement.lang

  if (lang === 'fr') {
    return ''
  }

  return `/${lang}`
}

window.ShopifyApi.getCartItems = async () => {
  const res = await fetch(`${getLocale()}/cart.json`);
  return await res.json();
}

window.ShopifyApi.suggest = async (query) => {
  const res = await fetch(`${getLocale()}/search/suggest.json?q=${query}`)
  return await res.json();
}

/**
 * @property items array
 * example: [{ id: additionalSampleId, quantity: 1, properties: { _is_additional_sample: true } }]
 */
window.ShopifyApi.addToCart = async(items, attributes = {}) => {
  // Create products
  return await fetch(`${getLocale()}/cart/add`, {
      method: "post",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({items, attributes})
  });
}

window.ShopifyApi.updateCartAttributes = async (attributes) => {
  var headers = new Headers({'Content-Type': 'application/json'});

  var request = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({ attributes })
  };

  return fetch(`${getLocale()}/cart/update.js`, request);
}

window.ShopifyApi.updateCartQuantity = async (updates) => {
  return await fetch(`${getLocale()}/cart/update.js`, {
    method: "post",
    headers: {
      Accept: "application/json", 
      "Content-Type": "application/json"
    },
    body: JSON.stringify({updates})
  });
}

window.ShopifyApi.updateCartItem = async (item) => {
  return await fetch(`${getLocale()}/cart/change.js`, {
    method: "post",
    headers: {
      Accept: "application/json", 
      "Content-Type": "application/json"
    },
    body: JSON.stringify(item)
  });
}

/*
 * Shopify Common JS
 *
 */
// set a given selector with value, if value is one of the options
window.Shopify.setSelectorByValue = function(selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

// send request as a POST
window.Shopify.postLink = function(path, options) {
  options = options || {};
  const method = options['method'] || 'post';
  const params = options['parameters'] || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
